'use strict';

angular.module('internal.applications')

    .controller('InternalApplicationPaymentsInitiate', ['$q', '$scope', '$window', '$filter', '$rootScope', '$stateParams', 'Payments', 'Regions', 'Resource', 'Format', function ($q, $scope, $window, $filter, $rootScope, $stateParams, Payments, Regions, Resource, Format) {
        $scope.licenseRequestID = $stateParams.id;
        }])
;